import { AnnouncementList } from './AnnouncementList';
export default AnnouncementList;
